import popConfirm from './pop-confirm'
import tip from './tip'
import highlight from './highlight'
import TreeTable from './tree-table'
import searchInput from './search-input'
import commonIcon from './common-icon'
import Badge from './badge'
import SubmitButton from './submit-btn'
import ImageUpload from './image-upload'
import ImagePreview from './image-preview'
import SelectDialog from './select-dialog'
import AuthPage from './page/auth'
import Map from './map'
import HMenu from './menu'
import HSelect from './select.vue'
import HCascader from './cascader.vue'
import DragDrawer from './drag-drawer'
import ExcelUploader from './excel-uploader'
import {
  Searchbar,
  DataGrid,
  TreeDataGrid,
  TabDataGrid,
  TabDataGridItem,
  ProfileBasic,
  ProfileStatusBar,
  VLayout
} from './layouts'

import {
  StatsHeader,
  Statistics
} from './statistics'

import Tree from './tree'
import Upload from './upload'
import { RankList, ChartCard } from './charts'

import Empty from './empty'
import { Description } from './descirption/index.js'

const components = {
  Searchbar,
  DataGrid,
  TreeDataGrid,
  popConfirm,
  tip,
  TreeTable,
  highlight,
  searchInput,
  commonIcon,
  Tree,
  TabDataGrid,
  TabDataGridItem,
  Badge,
  SubmitButton,
  ImageUpload,
  HMenu,
  ImagePreview,
  ProfileBasic,
  SelectDialog,
  Map,
  ProfileStatusBar,
  AuthPage,
  HSelect,
  HCascader,
  DragDrawer,
  ExcelUploader,
  Upload,
  RankList,
  ChartCard,
  Empty,
  StatsHeader,
  Statistics,
  VLayout,
  Description
}
//抽屉重命名
DragDrawer.name = "DragDrawer"

const install = Vue => {
  for (let key in components) {
    if (components.hasOwnProperty(key)) {
      let component = components[key]
      if (component.install) component.install(Vue)
      else {
        Vue.component(component.name ? component.name : key, component)
      }
    }
  }
}
export default {
  install,
  ...components
}



// WEBPACK FOOTER //
// ./src/components/index.js